// extracted by mini-css-extract-plugin
export default {"warning":"editTeamsPopup_warning__reQJg","button":"editTeamsPopup_button__qSlAd"};